export const calendarHead = ['Holiday Name','Month','Status','Modified By'];

export const calendarData = [
    {
        id:'1',
        holiday:'Eid Ul Adha',
        month:'Sun, Jul 10 2022',
        status:'Vacation',
        modifiedBy:'System'
    },
    {
        id:'2',
        holiday:'Eid Ul Adha',
        month:'Sun, Jul 10 2022',
        status:'Vacation',
        modifiedBy:'System'
    },
    {
        id:'3',
        holiday:'Eid Ul Adha',
        month:'Sun, Jul 10 2022',
        status:'Vacation',
        modifiedBy:'System'
    },
    {
        id:'4',
        holiday:'Eid Ul Adha',
        month:'Sun, Jul 10 2022',
        status:'Vacation',
        modifiedBy:'System'
    },
]